module.exports = __webpack_public_path__ + "static/media/compare_with_number.5b93887a.svg";